const colors = {
    mcslight: '#27aae1',
    mcsdark: '#1a3768',
    mcsred: '#dd3449',
    get primary() {
      return this.mcslight;
    },
    get secondary() {
      return this.mcsred;
    },
    white: '#fff',
    fakewhite: '#eeeeee',
    danger: '#ff4444',
    warning: '#ffbb33',
    success: '#00c851',
    info: '#33b5e5',
    softblack: '#444444',
    black: '#111111',
  };
  
  export default colors;